"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.sign = void 0;
var base_64_1 = __importDefault(require("base-64"));
var timespan_1 = require("./timespan");
var utils_1 = require("./utils");
/**
 * Sign a token
 * @param signer - A function that returns a signature string (Promise<string>)
 * @param opts - Options to sign the token
 * @returns A signed token
 * @example
 * ```ts
 * import { sign } from 'web3-signer';
 *
 * const token = await sign(signer, {
 *  domain: 'example.com',
 *  expires_in: '1d',
 * });
 * ```
 *
 * More examples refer to [README.md](https://github.com/EveripediaNetwork/web3-signer/blob/master/README.md)
 **/
var sign = function (signer, opts) {
    if (opts === void 0) { opts = '1d'; }
    return __awaiter(void 0, void 0, void 0, function () {
        var params, body, msg, signature, token;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    params = typeof opts === 'string' ? { expires_in: opts } : opts;
                    validateParams(params);
                    body = processParams(params);
                    msg = buildMessage(body);
                    return [4 /*yield*/, signer(msg)];
                case 1:
                    signature = _a.sent();
                    if (typeof signature !== 'string') {
                        throw new Error('"signer" argument should be a function that returns a signature string (Promise<string>)');
                    }
                    token = base_64_1["default"].encode(JSON.stringify({ signature: signature, body: msg }));
                    return [2 /*return*/, token];
            }
        });
    });
};
exports.sign = sign;
/**
 * Validate params
 * @param params - Params to validate
 * @returns void
 * @throws Error if params are invalid
 **/
var validateParams = function (params) {
    for (var key in params) {
        var value = params[key];
        if (typeof value === 'string' && /\n/.test(value)) {
            throw new Error("\"".concat(key, "\" option cannot have LF (\\n)"));
        }
    }
    if (params.domain !== undefined) {
        var domain = params.domain;
        if (!(0, utils_1.isValidString)(domain) || !(0, utils_1.isValidDomain)(domain)) {
            throw new Error('Invalid domain format (must be example.com)');
        }
    }
    if (params.uri !== undefined) {
        var uri = params.uri;
        if (!(0, utils_1.isValidString)(uri) || !(0, utils_1.isURL)(uri)) {
            throw new Error('Invalid uri format (must be https://example.com/login)');
        }
    }
    if (params.chain_id !== undefined) {
        var chainId = params.chain_id;
        if (!(0, utils_1.isNumber)(chainId)) {
            throw new Error('chain_id must be an int');
        }
    }
    if (params.expiration_time !== undefined) {
        var expirationTime = params.expiration_time;
        if (!(0, utils_1.isDate)(expirationTime)) {
            throw new Error('expiration_time must be an instance of Date');
        }
    }
    if (params.not_before !== undefined) {
        var notBefore = params.not_before;
        if (!(0, utils_1.isDate)(notBefore)) {
            throw new Error('not_before must be an instance of Date');
        }
    }
};
/**
 * Process params
 * @param params - Params to process
 * @returns Processed params
 **/
var processParams = function (params) {
    var _a;
    var body = {
        web3_token_version: '2',
        issued_at: new Date(),
        expiration_time: params.expiration_time
            ? new Date(params.expiration_time)
            : params.expires_in
                ? (0, timespan_1.timeSpan)(params.expires_in)
                : (0, timespan_1.timeSpan)('1d'),
        not_before: params.not_before ? new Date(params.not_before) : undefined,
        chain_id: params.chain_id ? parseInt(String(params.chain_id)) : undefined,
        uri: params.uri ||
            (typeof window !== 'undefined' && ((_a = window.location) === null || _a === void 0 ? void 0 : _a.href)) ||
            undefined,
        nonce: params.nonce
            ? parseInt(String(Math.random() * 99999999))
            : undefined,
        request_id: params.request_id,
        domain: params.domain,
        statement: params.statement
    };
    return body;
};
/**
 * Build message
 * @param params - Params to build message
 * @returns Message
 **/
var buildMessage = function (params) {
    var message = [];
    if (params.domain) {
        message.push("".concat(params.domain, " wants you to sign in with your Ethereum account."));
        message.push('');
    }
    if (params.statement) {
        message.push(params.statement);
        message.push('');
    }
    var paramLabels = {
        URI: params.uri,
        'Web3 Token Version': params.web3_token_version,
        'Chain ID': params.chain_id,
        Nonce: params.nonce,
        'Issued At': params.issued_at.toISOString(),
        'Expiration Time': params.expiration_time.toISOString(),
        'Not Before': params.not_before
            ? params.not_before.toISOString()
            : undefined,
        'Request ID': params.request_id
    };
    for (var label in paramLabels) {
        var value = paramLabels[label];
        if (value !== undefined) {
            message.push("".concat(label, ": ").concat(value));
        }
    }
    return message.join('\n');
};
